const CONTAIN_LETTERS_AND_NUMBERS = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/

const MIN_PASSWORD_LENGTH = 8

const MAX_PASSWORD_LENGTH = 32

const SIGN_UP_VALIDATIONS = ['name', 'family_name', 'username', 'password']

const SIGN_IN_VALIDATIONS = ['username', 'password']

const CHANGE_PASSWORD_VALIDATIONS = ['old_password', 'new_password', 'new_password_confirm']

export {
    CONTAIN_LETTERS_AND_NUMBERS,
    MAX_PASSWORD_LENGTH,
    MIN_PASSWORD_LENGTH,
    SIGN_IN_VALIDATIONS,
    SIGN_UP_VALIDATIONS,
    CHANGE_PASSWORD_VALIDATIONS
}